import {
  jwtDecode as jwtDecodeLib,
  JwtPayload as JwtPayloadLib,
} from 'jwt-decode';

interface JwtPayload extends JwtPayloadLib {
  account_uuid?: string;
  email?: string;
}

export function jwtDecode(
  jwt: string,
): [JwtPayload, undefined] | [undefined, Error] {
  try {
    return [jwtDecodeLib<JwtPayload>(jwt), undefined];
  } catch (error) {
    if (error instanceof Error) {
      return [undefined, error];
    }
    return [undefined, new Error('Cannot decode JWT')];
  }
}
